import React from 'react';

const FitQueenPrivacy = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Privacy Policy</h1>
      <p className="text-center text-gray-600 mb-4">FitQueen: Home Workout Women · Last updated: March 18, 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          N1 Inovasyon ("we", "our", "us") built FitQueen: Home Workout Women as a commercial application. This Privacy Policy explains how we collect, use, and protect your information when you use our App.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Information We Collect</h2>

        <h3 className="text-lg font-semibold mt-6">a) Information You Provide</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 mt-2">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Data</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Email address</td>
                <td className="border border-gray-300 px-4 py-2">Account creation & authentication</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Display name</td>
                <td className="border border-gray-300 px-4 py-2">Personalization within the App</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Fitness goals</td>
                <td className="border border-gray-300 px-4 py-2">Recommending suitable workout programs</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Current & target weight</td>
                <td className="border border-gray-300 px-4 py-2">Weight tracking feature</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="text-lg font-semibold mt-6">b) Information Generated by Your Use</h3>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 mt-2">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Data</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Workout history & streak data</td>
                <td className="border border-gray-300 px-4 py-2">Progress tracking & achievements</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Exercise rep counts</td>
                <td className="border border-gray-300 px-4 py-2">Performance statistics</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Weight history entries</td>
                <td className="border border-gray-300 px-4 py-2">Weight tracking over time</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Program progress</td>
                <td className="border border-gray-300 px-4 py-2">Resuming programs where you left off</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="text-lg font-semibold mt-6">c) Information We Do NOT Collect</h3>
        <ul className="list-disc ml-6 space-y-2">
          <li><strong>Camera data:</strong> The App uses your device's camera solely for real-time pose detection. No video, photos, or images are recorded, saved, stored, or transmitted. All camera processing happens entirely on your device using Apple's Vision Framework.</li>
          <li><strong>Biometric data:</strong> We do not collect or store any biometric identifiers.</li>
          <li><strong>Location data:</strong> We do not collect your geographic location.</li>
          <li><strong>Contacts, photos, or files:</strong> We do not access your contacts, photo library, or file system.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">2. How We Use Your Information</h2>
        <p>We use the information we collect to:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Provide and maintain the App's features and functionality.</li>
          <li>Track your workout progress, streaks, and achievements.</li>
          <li>Personalize your experience with relevant workout recommendations.</li>
          <li>Process subscriptions and manage your account.</li>
          <li>Improve the App and develop new features.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">3. Third-Party Services</h2>
        <p>We use the following third-party services:</p>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300 mt-2">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Service</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Privacy Policy</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Firebase (Google)</td>
                <td className="border border-gray-300 px-4 py-2">Authentication, database, cloud storage</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a href="https://firebase.google.com/support/privacy" className="text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer">Link</a>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">RevenueCat</td>
                <td className="border border-gray-300 px-4 py-2">Subscription management & payment processing</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a href="https://www.revenuecat.com/privacy" className="text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer">Link</a>
                </td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">Apple Sign In</td>
                <td className="border border-gray-300 px-4 py-2">Secure authentication</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a href="https://www.apple.com/legal/privacy/" className="text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer">Link</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mt-4">
          These services may collect information as described in their respective privacy policies. We do not sell, trade, or rent your personal information to any third party.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Data Storage & Security</h2>
        <p>
          Your data is stored in Firebase Cloud Firestore, operated by Google. We implement appropriate technical and organizational measures to protect your personal data, including encrypted data transmission (HTTPS/TLS), secure authentication tokens, and Firestore Security Rules that restrict access to your data to only your authenticated account.
        </p>

        <h2 className="text-xl font-semibold mt-8">5. Data Retention</h2>
        <p>
          We retain your personal data for as long as your account is active. When you delete your account through the App's Settings, all associated data (profile information, workout history, weight records, and achievements) is permanently deleted from our servers. Subscription data managed by Apple and RevenueCat is subject to their respective retention policies.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Your Rights</h2>
        <p>You have the right to:</p>
        <ul className="list-disc ml-6 space-y-2">
          <li>Access your personal data through the App.</li>
          <li>Update your profile information at any time.</li>
          <li>Delete your account and all associated data through Settings → Delete Account.</li>
          <li>Cancel your subscription at any time through App Store Settings.</li>
          <li>Request a copy of your data by contacting us at the email below.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">7. Children's Privacy</h2>
        <p>
          The App is not intended for children under the age of 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us so we can take appropriate action.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. International Users</h2>
        <p>
          Your data may be processed and stored in countries outside your country of residence, including the United States (where Firebase/Google Cloud servers are located). By using the App, you consent to the transfer and processing of your data in these locations.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the updated policy within the App or on our website. Your continued use of the App after changes constitutes acceptance of the updated policy.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy, or wish to exercise your data rights, please contact us at:
        </p>
        <p className="ml-4">
          E-mail: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600 hover:text-blue-800">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            By using this application, you confirm that you have read and accepted the above privacy policy.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FitQueenPrivacy;
